import { ApiAppNamespaces, IQueuedRequest, OneAPIOptions } from '../../common'
import { AppProductsApi } from './app'
import { Queue } from '../../queue'

export class ProductsApp implements ApiAppNamespaces {
  app: AppProductsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppProductsApi(name, sessionId, requestsQueue, options)
  }

  invalidateAll() {
    this.app.invalidateAll()
  }
}
